import { HttpHandler } from 'msw'

import { addPrivateCard } from './addPrivateCard'
import { deletePrivateCard } from './deletePrivateCard'
import { updatePassword } from './updatePassword'
import { updateUser } from './updateUser'

export const account: HttpHandler[] = [
    addPrivateCard,
    deletePrivateCard,
    updatePassword,
    updateUser,
]
